import React from 'react'

export default function SignUp() {
  return (
    <div className='mt-28'>
      Sign Up
    </div>
  )
}
